module.exports = __webpack_public_path__ + "img/Jupiter.35d71d72.35d71d72.png";